/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { get } from '../../helpers/api_helper';

function Refund(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t, reference } = props;

  const [data, setData] = useState(null);
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    try {
      setLoading(true);
      const storeInfo = await get('/api/bc/info');
      const res = await get(`/api/bc/sale/inspect/${reference}`);

      setData(res);
      setInfo(storeInfo);
    } catch (e) {
      toastr.error(t('Error loading BigCommerce sales data'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [reference]);

  const jsx = (
    <>
      {data !== null && info !== null && (
        <div>
          <a
            href={`${info.control_panel_base_url}/manage/orders/${data.id}/refund`}
            target="_blank"
            rel="noreferrer"
          >
            {t('Refund on BigCommerce')}
            {' '}
            <span className="bx bx-window-open" />
          </a>
        </div>
      )}

      {(data === null || info === null) && (
        <div>
          {loading === true && (
            <p>
              <span className="mdi mdi-spin mdi-loading" />
              {' '}
              {t('Loading...')}
            </p>
          )}

          {loading === false && (
            <p>Could not find order on BigCommerce</p>
          )}
        </div>
      )}
    </>
  );

  return jsx;
}

Refund.defaultProps = {
  t: (w) => w,
};

Refund.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  reference: PropTypes.string.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(Refund));
